export default "__VITE_ASSET__D7H$X3vv__"